export var Operator;
(function (Operator) {
    Operator[Operator["GREATER_THAN"] = 1] = "GREATER_THAN";
    Operator[Operator["LESS_THAN"] = 2] = "LESS_THAN";
})(Operator || (Operator = {}));
export var ActiveSLAState;
(function (ActiveSLAState) {
    ActiveSLAState[ActiveSLAState["ALL"] = 0] = "ALL";
    ActiveSLAState[ActiveSLAState["ALMOST_MISSED"] = 1] = "ALMOST_MISSED";
    ActiveSLAState[ActiveSLAState["MISSED"] = 2] = "MISSED";
    ActiveSLAState[ActiveSLAState["REMAINING_TIME"] = 3] = "REMAINING_TIME";
    ActiveSLAState[ActiveSLAState["MISSED_TIME"] = 4] = "MISSED_TIME";
})(ActiveSLAState || (ActiveSLAState = {}));
//# sourceMappingURL=sla-policies-filters.i.js.map